import { visit } from "unist-util-visit";

export default function remarkCitations() {
  return (tree) => {
    visit(tree, "text", (node, index, parent) => {
      const regex = /\[\[\[(\d+)\]\[(.*?)\]\]\]/g;
      let matches = Array.from(node.value.matchAll(regex));

      // If no matches found, return without modifying
      if (matches.length === 0) return;

      const newNodes = [];
      let lastIndex = 0;

      matches.forEach((match) => {
        const [fullMatch, citationNumber, source] = match;
        const start = match.index;

        // Add text before the citation if any
        if (start > lastIndex) {
          newNodes.push({
            type: "text",
            value: node.value.slice(lastIndex, start),
          });
        }

        // Add the citation node
        newNodes.push({
          type: "citation", // Change this from "element" with tagName "citation"
          data: {
            hName: "citation",
            hProperties: { source: source.trim() },
          },
          children: [
            {
              type: "text",
              value: `[${citationNumber}]`,
            },
          ],
        });

        lastIndex = start + fullMatch.length;
      });

      // Add any remaining text
      if (lastIndex < node.value.length) {
        newNodes.push({
          type: "text",
          value: node.value.slice(lastIndex),
        });
      }

      // Replace the original node with our new nodes
      parent.children.splice(index, 1, ...newNodes);
      return index + newNodes.length - 1; // Skip the nodes we just added
    });
  };
}
